export const MIGRATION_SESSION = '/api/v1/migration/session/';
export default { MIGRATION_SESSION };
